export default [
  {
    path: '/games',
    name: 'games',
    component: () => import('@/views/game/GamesList.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/edit/:id',
    name: 'game-edit',
    component: () => import('@/views/game/GameEdit.vue'),
    meta: {
      navActiveLink: 'games',
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/new',
    name: 'random-game-create',
    component: () => import('@/views/game/RandomGameCreate.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/schedule-import',
    name: 'schedule-import',
    component: () => import('@/views/game/ScheduleImport.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/weeks',
    name: 'game-weeks',
    component: () => import('@/views/game/GameWeeks.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/planfix',
    name: 'planfix-games',
    component: () => import('@/views/game/PlanfixGamesList.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/planfix-packs',
    name: 'planfix-packs',
    component: () => import('@/views/game/PlanfixPacksList.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/reminders',
    name: 'game-reminders',
    component: () => import('@/views/game/GameReminders.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/telegram-sync',
    name: 'telegram-sync',
    component: () => import('@/views/game/TelegramSync.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/builder',
    name: 'game-builder-list',
    component: () => import('@/views/game/builder/GameBuilderList.vue'),
    meta: {
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/builder/new',
    name: 'game-builder-create',
    component: () => import('@/views/game/builder/GameBuilderView.vue'),
    meta: {
      navActiveLink: 'game-builder-list',
      resource: 'games',
      action: 'view',
    },
  },
  {
    path: '/games/builder/:id',
    name: 'game-builder',
    component: () => import('@/views/game/builder/GameBuilderView.vue'),
    meta: {
      navActiveLink: 'game-builder-list',
      resource: 'games',
      action: 'view',
    },
  },
]
